// extracted by mini-css-extract-plugin
export default {"wrap":"bb_cQ","navItem":"bb_bP"};